import type { SxProps, Theme } from '@mui/material';

export const card: SxProps<Theme> = (theme: Theme) => ({
  background:
    theme.palette.mode === 'dark'
      ? 'linear-gradient(180deg, rgba(29,17,44,1) 0%, rgba(43,30,57,1) 100%)'
      : 'linear-gradient(180deg, rgba(250,250,250,1) 0%, rgba(240,240,240,1) 100%)',
  border: `1px solid ${theme.palette.divider}`,
  position: 'relative',
  overflow: 'hidden',
});

export const cardContent: SxProps<Theme> = (theme: Theme) => ({
  p: 4,
  textAlign: 'center',
  position: 'relative',
  zIndex: 2,
  backgroundImage:
    theme.palette.mode === 'dark'
      ? 'url(/NeedHelpCardDark.png)'
      : 'url(/NeedHelpCardLight.png)',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
});

export const contentContainer: SxProps<Theme> = {
  maxWidth: 473,
  mx: 'auto',
};

export const iconImage: SxProps<Theme> = {
  width: 27,
  height: 25,
  mb: 2,
};

export const titleTypography: SxProps<Theme> = {
  mb: 2,
};

export const descriptionTypography: SxProps<Theme> = {
  mb: 3,
};

export const buttonsContainer: SxProps<Theme> = {
  display: 'flex',
  gap: 2,
  justifyContent: 'center',
};

export const contactButton: SxProps<Theme> = {
  flex: 1,
  maxWidth: 200,
  color: '#b388ff',
  borderColor: 'rgba(149, 117, 205, 0.5)',
  '&:hover': {
    borderColor: '#b388ff',
  },
};

export const docsButton: SxProps<Theme> = {
  flex: 1,
  maxWidth: 200,
};
